import { Component, ViewChild } from '@angular/core';
import { Config, Nav, Platform, MenuController, Events } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { HomePage } from '../pages/home/home';
import { EbsWebServiceGlobals } from "../services/ebsWebServiceGlobals";
import { EbsWebService } from "../services/ebsWebService";
import { EbsComponentService } from "../services/ebsComponentService";
import { LoginPage } from '../pages/login/login';
import { Storage } from '@ionic/storage';
import { AndroidFullScreen } from '@ionic-native/android-full-screen';

declare var $;
@Component({
  templateUrl: 'app.html'
})

export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any;
  loginPage: boolean = true;
  loginUrl: any = "";
  webServiceResponse: any = "";
  showErrorPage = false;
  pages: any = [];
  loginObject: any = "";
  showSpinner: boolean = true;
  sidenavClock: any;

  constructor(public platform: Platform,
    config: Config,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    private _ebsWebServiceGlobals: EbsWebServiceGlobals,
    private _ebsWebService: EbsWebService,
    private _ebsComponentService: EbsComponentService,
    private menuCtrl: MenuController,
    public events: Events,
    private storage: Storage,
    private androidFullScreen: AndroidFullScreen) {

    config.set('mode', 'ios');

    this.pages = [];

    //this.loginPage = false;
    this.menuCtrl.enable(true);

    events.subscribe('setting:ConfigFileLoaded', () => {
      this.initializeApp();
      this.buildAppFromWebService();
      events.unsubscribe('setting:ConfigFileLoaded', null);
    });

    events.subscribe('setting:LoginPage', () => {
      this.loginPage = false;
      this.menuCtrl.enable(true);
      this._ebsWebServiceGlobals.setShowLoginScreen(false);
      this.buildAppFromWebService();
      this.rootPage = HomePage;
    });

    events.subscribe("reloadMenu", () => {
      if (this._ebsWebServiceGlobals.getReloadMenu()) {
        this.reloadMenu();
      }
    });
  }

  buildAppFromWebService() {
    let queryParams = JSON.parse(this._ebsWebService.buildPostPayloadObjectFromGetParameters(window.location.search.substring(1)));
    let postPayload = { userKey: "null" };
    let hasHash = false;
    if (queryParams != undefined && queryParams != null && queryParams['hash'] != undefined && queryParams['hash'] != null) {
      let hash = queryParams['hash'];
      console.log('hash found in query string:', hash);
      postPayload.userKey = hash;
      hasHash = true;
    } else {
      console.log('no hash found in query string');
    }

    this._ebsWebService.postData(this._ebsWebServiceGlobals.getEbsWebServiceMainNavigationURL(), hasHash ? postPayload : null).subscribe(res => {
      this.webServiceResponse = res;
      this.setProjectSpecificStyles();
      this.loadLoginScreenSettingFromWebService(res);
      this.loadIconsIfChangedFromWebserviceToLocalStorage(res);
      this.loginObject = res.LoginData;
      this._ebsWebService.setBrowserTabTitle(res.MainTitle);
      this.loadMenuFromWebService(res);
      this.showSpinner = false;
      setTimeout(() => { //Check after 5 Seconds if icons loaded correct
        this.checkIfIconsNotLoadedCorrect(res);
      }, 5000);
      this.checkParameter();
    });

    //Show Error Page if no Response after some Time
    setTimeout(() => {
      this.showErrorPage = true;
    }, 5000);
  }

  setProjectSpecificStyles() {
    if (this._ebsWebServiceGlobals.getProjectIdentifier() != "") {
      let stylePath = "assets/css/" + this._ebsWebServiceGlobals.getProjectIdentifier() + ".css";
      $('head').append('<link rel="stylesheet" type="text/css" href=' + stylePath + '>');
    }
  }

  loadLoginScreenSettingFromWebService(res) {
    if (res.LoginUrl == null || res.LoginUrl == "" || typeof res.LoginUrl == "undefined") {
      this._ebsWebServiceGlobals.setShowLoginScreen(false);
    } else {
      this._ebsWebServiceGlobals.setLoginUrl(res.LoginUrl);
      this._ebsWebServiceGlobals.setShowLoginScreen(true);
    }
  }

  setRootPage() {
    if (this._ebsWebServiceGlobals.getShowLoginScreen()) {
      this.menuCtrl.enable(false);
      this.loginPage = true;
      this.nav.setRoot(LoginPage, { loginObject: this.loginObject });
    } else {
      this.menuCtrl.enable(true);
      this.loginPage = false;

      if (this._ebsWebServiceGlobals.getAlternativeHomeScreen() != "" && this._ebsWebServiceGlobals.getAlternativeHomeScreen() != null) {
        setTimeout(() => {
          this.pages.forEach(page => {
            page.submenus.forEach(subpage => {
              if (subpage.title.toLowerCase() == this._ebsWebServiceGlobals.getAlternativeHomeScreen().toLowerCase()) {
                this.openPage(subpage);
              }
            });
          });
        });
      } else {
        this.rootPage = HomePage;
      }
    }
  }

  loadIconsIfChangedFromWebserviceToLocalStorage(res, brokenIcons = false) {
    if (typeof res.CurrentIconDataHash != "undefined" && res.CurrentIconDataHash != null) {
      this._ebsWebService.getIconsLastChangeDate().then((lastDate) => {
        if (res.CurrentIconDataHash != lastDate || brokenIcons) {
          this._ebsWebService.setIconsLastChangeDate(res.CurrentIconDataHash);
          let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(res.ActionGetIconDataPostParameters);
          this._ebsWebService.postData(res.ActionGetIconData, postPayloadObject).subscribe(res => {
            this.loadIconsFromWebService(res);
          });
        }
      })
    }
  }

  async checkIfIconsNotLoadedCorrect(res) {
    if (typeof res != "undefined" && res.ListItemNavigation != "undefined" && res != null && res.ListItemNavigation != null && res.ListItemNavigation.length != 0) {
      let firstItemFileName = res.ListItemNavigation[0].Icon;
      let base64Image = await Promise.resolve(this.storage.get(firstItemFileName));
      if (base64Image == null || typeof base64Image == "undefined" || base64Image == "") {
        this.loadIconsIfChangedFromWebserviceToLocalStorage(res, true);
      }
    }
  }

  loadIconsFromWebService(res) {
    if (typeof res.ListItemIcon != "undefined" && res.ListItemIcon != null && res.ListItemIcon.length) {
      this._ebsWebService.setIconsInStorage(res.ListItemIcon);
    }
  }

  reloadMenu() {
    this._ebsWebService.postData(this._ebsWebServiceGlobals.getEbsWebServiceMainNavigationURL(), null).subscribe(res => {
      if (typeof res.ListItemNavigation != "undefined" && res.ListItemNavigation != null) {
        let oldPages = this.pages;
        let newPages = [];
        //this.pages = [];
        let amountNoCollapsible = 0;

        // if no clock in response remove pre existing clock
        if (!res.ListItemNavigation.some(element => element.Dynamic.Clock)) {
          this.removeClock();
        }

        res.ListItemNavigation.forEach(element => {
          let component = this._ebsComponentService.getComponentByAction(element.ViewTypeAction);

          let paddingTopCSS;
          if (typeof element.Dynamic != "undefined" && typeof element.Dynamic != null && element.Dynamic.PaddingTop != "") {
            paddingTopCSS = element.Dynamic.PaddingTop + "px";
          }

          let menuSubtitle;
          if (typeof element.Dynamic != "undefined" && typeof element.Dynamic != null && element.Dynamic.MenuSubtitle) {
            menuSubtitle = element.Dynamic.MenuSubtitle;
          }

          let badge;
          if (typeof element.Dynamic != "undefined" && typeof element.Dynamic != null && element.Dynamic.Badge) {
            badge = element.Dynamic.Badge;
            if (badge == "0") {
              badge = null;
            }
          }

          let clock;
          if (typeof element.Dynamic != "undefined" && typeof element.Dynamic != null && element.Dynamic.Clock) {
            clock = element.Dynamic.Clock;
            clock = clock.split(/[. :]/);
            clock = new Date(Date.UTC(clock[0], clock[1] - 1, clock[2], clock[3], clock[4], clock[5]));
          }
          if (clock == undefined) {
            let currpage = newPages.find(menu => menu.title == menuSubtitle);

            if (currpage != undefined) {
              currpage.submenus.push({
                title: element.Caption,
                ActionType: element.ActionType,
                component: component,
                actionURL: element.Action,
                icon: element.Icon,
                actionParams: element.PostParameters,
                badge: badge
              });
            } else {
              let subm = [];
              subm.push({
                title: element.Caption,
                ActionType: element.ActionType,
                component: component,
                actionURL: element.Action,
                icon: element.Icon,
                actionParams: element.PostParameters,
                badge: badge
              });
              newPages.push({ title: menuSubtitle == undefined ? 'nix_' + amountNoCollapsible++ : menuSubtitle, submenus: subm, collapsed: menuSubtitle != undefined, paddingTop: paddingTopCSS, showCollapsible: menuSubtitle != undefined });
            }
          } else {
            let prevTime = undefined;
            if (this.sidenavClock != undefined) {
              prevTime = this.sidenavClock.displayTime;
              this.removeClock();
            }
            this.addClock(prevTime, clock, {
              title: element.Caption,
              ActionType: element.ActionType,
              component: component,
              actionURL: element.Action,
              icon: element.Icon,
              actionParams: element.PostParameters,
              badge: badge
            });
          }
        });

        this.pages = newPages;

        for (let oldPage of oldPages) {
          let newPage = this.pages.find(newPage => newPage.title == oldPage.title);
          if (newPage != undefined && newPage.collapsed != oldPage.collapsed) {
            newPage.collapsed = oldPage.collapsed;
            console.log('should be collapsed', newPage);
          }
        }
      }
    });
    console.log(this.pages);
  }



  loadMenuFromWebService(res) {
    if (typeof res.ListItemNavigation != "undefined" && res.ListItemNavigation != null) {
      let amountNoCollapsible = 0;
      res.ListItemNavigation.forEach(element => {
        let component = this._ebsComponentService.getComponentByAction(element.ViewTypeAction);
        let paddingTopCSS;
        if (typeof element.Dynamic != "undefined" && typeof element.Dynamic != null && element.Dynamic.PaddingTop != "") {
          paddingTopCSS = element.Dynamic.PaddingTop + "px";
        }

        let menuSubtitle;
        if (typeof element.Dynamic != "undefined" && typeof element.Dynamic != null && element.Dynamic.MenuSubtitle) {
          menuSubtitle = element.Dynamic.MenuSubtitle;
        }

        let badge;
        if (typeof element.Dynamic != "undefined" && typeof element.Dynamic != null && element.Dynamic.Badge) {
          badge = element.Dynamic.Badge;
          if (badge == "0") {
            badge = null;
          }
        }

        let clock;
        if (typeof element.Dynamic != "undefined" && typeof element.Dynamic != null && element.Dynamic.Clock) {
          clock = element.Dynamic.Clock;
          console.log('CLOCK ELEMENT: ', element);
          console.log(clock);
          clock = clock.split(/[. :]/);
          clock = new Date(Date.UTC(clock[0], clock[1] - 1, clock[2], clock[3], clock[4], clock[5]));
        }

        if (clock == undefined) {
          let currpage = this.pages.find(menu => menu.title == menuSubtitle);

          if (currpage != undefined) {
            currpage.submenus.push({
              title: element.Caption,
              ActionType: element.ActionType,
              component: component,
              actionURL: element.Action,
              icon: element.Icon,
              actionParams: element.PostParameters,
              badge: badge
            });
          } else {
            let subm = [];
            subm.push({
              title: element.Caption,
              ActionType: element.ActionType,
              component: component,
              actionURL: element.Action,
              icon: element.Icon,
              actionParams: element.PostParameters,
              badge: badge
            });
            this.pages.push({ title: menuSubtitle == undefined ? 'nix_' + amountNoCollapsible++ : menuSubtitle, submenus: subm, collapsed: menuSubtitle != undefined, paddingTop: paddingTopCSS, showCollapsible: menuSubtitle != undefined });
          }
        } else {
          let prevTime = undefined;
          if (this.sidenavClock != undefined) {
            prevTime = this.sidenavClock.displayTime;
            this.removeClock();
          }
          this.addClock(prevTime, clock, {
            title: element.Caption,
            ActionType: element.ActionType,
            component: component,
            actionURL: element.Action,
            icon: element.Icon,
            actionParams: element.PostParameters,
            badge: badge
          });
        }
      });
      console.log(this.pages);
    }
  }

  addClock(displayTime, startTime, element) {
    this.sidenavClock = {
      displayTime: displayTime,
      time: startTime,
      interval: setInterval(() => {
        this.sidenavClock.displayTime = new Date(new Date().getTime() - this.sidenavClock.time.getTime()).toTimeString().substring(0, 8);
      }, 100),
      element: element
    }
  }

  removeClock() {
    if (this.sidenavClock != undefined) {
      clearInterval(this.sidenavClock.interval);
      this.sidenavClock = undefined;
    }
  }

  initializeApp() {
    console.log('not ready');
    this.platform.ready().then(() => {
      console.log('ready');
      this.statusBar.styleDefault();
      this.statusBar.overlaysWebView(false);
      this.splashScreen.hide();
      this.androidFullScreen.immersiveMode();

      let http2redirect = this._ebsWebServiceGlobals.getHttp2Redirect();
      if (http2redirect != undefined && http2redirect != '') {
        if (!window.location.href.includes(http2redirect)) {
          this._ebsWebService.postData(this._ebsWebServiceGlobals.getEbsWebServiceMainNavigationURL(), this._ebsWebService.buildPostPayloadObjectFromGetParameters(null)).toPromise().then(res => {
            window.location.href = "./" + http2redirect + window.location.search;
          }).catch(err => {
            window.location.href = "./" + http2redirect + window.location.search;
          });
        }
      }
    });
  }

  openPage(page) {
    console.log(page);
    setTimeout(() => {
      this.events.publish("reloadMenu");
    }, 500);
    let navParams = {
      title: page.title,
      actionURL: page.actionURL,
      postParams: page.actionParams
    };
    if (typeof page.component != "undefined" && typeof page.component != null && page.component == "Link") {
      let params = JSON.parse(this._ebsWebService.buildPostPayloadObjectFromGetParameters(page.actionParams));
      console.log(params);
      window.open(params.action);
    } else {
      this._ebsComponentService.navigationController(page, navParams, this.nav, page.component);
    }
  }

  openHomePage() {
    this.rootPage = HomePage;
    this.openPage(this.rootPage);
  }

  checkParameter() {
    var action = this._ebsWebServiceGlobals.getParameterByName("Action");
    var district = this._ebsWebServiceGlobals.getParameterByName("District");
    var id = this._ebsWebServiceGlobals.getParameterByName("id");
    var searchword = this._ebsWebServiceGlobals.getParameterByName("searchWord");

    let parAction = "";
    if (action != null && action != "" && typeof action != "undefined") {
      parAction = action;
    }
    let parDistrict = "";
    if (district != null && district != "" && typeof district != "undefined") {
      parDistrict = district;
    }
    let parId = "";
    if (id != null && id != "" && typeof id != "undefined") {
      parId = id;
    }
    let parSearchword = "";
    if (searchword != null && searchword != "" && typeof searchword != "undefined") {
      parSearchword = searchword;
    }

    if (parDistrict != null && parDistrict != "") {
      let params = {
        action: parAction,
        district: parDistrict,
        id: parId,
        searchword: parSearchword
      }
      setTimeout(() => {
        this._ebsComponentService.urlNavigationController(params, this.nav);
      }, 500);
      this.menuCtrl.enable(true);
      this.loginPage = false;
    } else {
      this.setRootPage();
    }
  }

  openDebugUrlWithPostParams(url, paramsJson) {
    var f = $("<form target='_blank' method='POST' style='display:none;'></form>").attr({
      action: url
    }).appendTo(document.body);
    let params = JSON.parse(paramsJson);
    for (var i in params) {
      if (params.hasOwnProperty(i)) {
        $('<input type="hidden" />').attr({
          name: i,
          value: params[i]
        }).appendTo(f);
      }
    }
    f.submit();
    f.remove();
  }

  collapseMenuMobile(event, page) {
    event.stopPropagation(); // prevents closing sidemenu on click
    page.collapsed = !page.collapsed;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts